document.addEventListener('turbo:load', function() {
  const sortableTables = document.querySelectorAll('.table-sortable tbody');
  
  sortableTables.forEach(tbody => {
    new Sortable(tbody, {
      animation: 150,
      draggable: '.item',
      
      onEnd: function(evt) {
        const item = evt.item;
        const itemData = item.dataset;
        const newIndex = evt.newIndex + 1;
        
        const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
        
        const params = {
          [itemData.modelName]: { position: newIndex }
        };
        
        fetch(itemData.updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': token,
            'X-HTTP-Method-Override': 'PUT'
          },
          body: JSON.stringify(params)
        }).then(() => {
          // Highlight effect using CSS animation on td elements
          const cells = item.querySelectorAll('td');
          cells.forEach(cell => cell.classList.add('highlight-flash'));
          setTimeout(() => {
            cells.forEach(cell => cell.classList.remove('highlight-flash'));
          }, 1000);
        });
      }
    });
  });
});
 